<template>
  <div class="biz-chart-box">
    <div class="chart-title">
      <img class="charts-icon" :src="require('@/assets/images/largescreen/charts-icon.png')" alt="">
      <dv-decoration-1 />
      <span>分区域逐月回款达成率</span>
    </div>
    <div ref="chart" class="biz-chart-container"></div>
  </div>
</template>

<script>
import resize from '@/utils/resize'

export default {
  name: 'BizMonthlyRepayment',
  mixins: [resize],
  props: {
    chartData: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    chartData: {
      handler(v) {
        if (v && v.length) this.initChart()
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {
    this.$nextTick(() => {
      if (this.chartData && this.chartData.length) this.initChart()
    })
  },
  beforeDestroy() {
    if (this.chart) {
      this.chart.dispose()
      this.chart = null
    }
  },
  methods: {
    initChart() {
      if (!this.$refs.chart) return
      if (this.chart) {
        this.chart.dispose()
      }
      this.chart = this.$echarts.init(this.$refs.chart)
      const data = this.chartData
      const regionNames = ['华东区', '华北区', '华南区', '华西区', '华中区']
      const colors = ['#24CBF1', '#EF557D', '#E6A23C', '#09F9CD', '#868EF9']
      const months = data.map(d => d.month || '')
      const series = regionNames.map((name, i) => ({
        name,
        type: 'line',
        data: data.map(d => d[name] || 0),
        smooth: true,
        itemStyle: { color: colors[i] },
        lineStyle: { width: 2 }
      }))
      const option = {
        color: colors,
        tooltip: {
          trigger: 'axis',
          backgroundColor: 'rgba(0, 0, 0, 0.8)',
          borderColor: '#00f2fe',
          textStyle: { color: '#fff' }
        },
        legend: {
          data: regionNames,
          textStyle: { color: '#fff', fontSize: 11 },
          top: 0
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '15%',
          top: '20%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: months,
          axisLabel: { color: '#fff', fontSize: 11, interval: 0, rotate: months.length > 6 ? 30 : 0 },
          axisLine: { lineStyle: { color: 'rgba(255,255,255,0.3)' } }
        },
        yAxis: {
          type: 'value',
          name: '回款率(%)',
          max: 100,
          nameTextStyle: { color: '#fff', fontSize: 11 },
          axisLabel: { formatter: '{value}%', color: '#fff', fontSize: 11 },
          splitLine: { lineStyle: { color: 'rgba(255,255,255,0.1)' } },
          axisLine: { lineStyle: { color: 'rgba(255,255,255,0.3)' } }
        },
        series
      }
      this.chart.setOption(option)
    }
  }
}
</script>

<style lang="scss" scoped>
.biz-chart-box {
  background: rgba(10, 57, 130, 0.6);
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  .chart-title {
    display: flex;
    align-items: center;
    color: #fff;
    font-weight: bolder;
    padding: 8px 15px;
    background: rgba(10, 57, 130, 0.6);
    position: relative;
    flex-shrink: 0;

    .charts-icon {
      width: 20px;
      height: 25px;
      position: absolute;
      left: 15px;
      top: 50%;
      transform: translateY(-50%);
    }

    .dv-decoration-1 {
      width: 60px;
      height: 20px;
      margin-left: 40px;
    }

    span {
      margin-left: 10px;
      font-size: 16px;
    }
  }

  .biz-chart-container {
    flex: 1;
    width: 100%;
    min-height: 0;
  }
}
</style>
